import { render, staticRenderFns } from "./ExpertDetails.vue?vue&type=template&id=b34cf222"
import script from "./ExpertDetails.vue?vue&type=script&lang=js"
export * from "./ExpertDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports